// extracted by mini-css-extract-plugin
export default {"divBox":"appBadge_divBox__aj21s","new":"appBadge_new__MZGhl","connected":"appBadge_connected__cA1cW","not_connected":"appBadge_not_connected__AhE39"};